import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "GjejShqip";
const DEF_TITLE = "GjejShqip - Gjej çka të duhet.";
const DEF_DESC = "GjejShqip – platforma për shqiptarët në diasporë. Gjej biznese, restorante, punë, banim, udhëtime, shërbime dhe oferta pranë teje.";
const PRIVATE = /^\/(admin|profil|mesazhe|njoftimet|gjejkredit|piket|publiko|ndrysho|qr|skano|q$|cilesimet|siguria|reset|te-ruajtura|shoqeria|kerkesat|perdorues|trego-biznes|krijo-profil-pune)/;

const meta = (attr, key, val) => {
  let m = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!m) { m = document.createElement("meta"); m.setAttribute(attr, key); document.head.appendChild(m); }
  m.setAttribute("content", val);
};
const link = (rel, href) => {
  let l = document.head.querySelector(`link[rel="${rel}"]`);
  if (!l) { l = document.createElement("link"); l.rel = rel; document.head.appendChild(l); }
  l.href = href;
};
const jsonld = (data) => {
  let s = document.getElementById("gs-jsonld");
  if (!data) { s && s.remove(); return; }
  if (!s) { s = document.createElement("script"); s.type = "application/ld+json"; s.id = "gs-jsonld"; document.head.appendChild(s); }
  s.textContent = JSON.stringify(data);
};

function apply({ title, description, image, data }) {
  const t = title ? `${title} | ${SITE}` : DEF_TITLE;
  const d = (description || DEF_DESC).replace(/\s+/g, " ").slice(0, 160);
  document.title = t;
  meta("name", "description", d);
  meta("property", "og:title", t);
  meta("property", "og:description", d);
  meta("property", "og:url", window.location.origin + window.location.pathname);
  meta("name", "twitter:title", t);
  meta("name", "twitter:description", d);
  if (image) { meta("property", "og:image", image); meta("name", "twitter:image", image); }
  jsonld(data);
}

// Resets defaults on each route (runs before page effects), sets canonical + robots
export function RouteSeo() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    apply({});
    link("canonical", window.location.origin + pathname);
    meta("name", "robots", PRIVATE.test(pathname) ? "noindex, nofollow" : "index, follow");
  }, [pathname]);
  return null;
}

export function useSeo(opts, deps) {
  useEffect(() => {
    if (opts) apply(opts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export const breadcrumb = (items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: window.location.origin + path })),
});
